import React from 'react';
import { Modal, ModalContents, ModalTitle, ModalButton } from 'components/Modal/Modal';
import { ExternalMatchRequestRule } from 'generated/graphql';
import { Typography } from '@mui/material';

interface DeleteRuleModalProps {
  deleteDialogOpen: boolean;
  handleCancelDelete: () => void;
  ruleToDelete: ExternalMatchRequestRule | null;
  deletingRule: boolean;
  handleDeleteRule: () => void;
  children: React.ReactNode;
}

const DeleteRuleModal: React.FC<DeleteRuleModalProps> = ({
  deleteDialogOpen,
  handleCancelDelete,
  ruleToDelete,
  deletingRule,
  handleDeleteRule,
  children,
}) => {
  const title = `Delete ${ruleToDelete?.type === 'approval' ? 'Auto-Approve' : 'Auto-Deny'} Rule`;
  return (
    <Modal
      open={deleteDialogOpen}
      onClose={handleCancelDelete}
      style={{
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ModalContents
        onClickClose={handleCancelDelete}
        body={
          <>
            <ModalTitle style={{ marginBottom: 28 }}>{title}</ModalTitle>
            <Typography variant="body1" fontSize="1rem" sx={{ mb: 2 }}>
              You’re about to delete the rule:
            </Typography>
            {children}
            <Typography variant="body1" fontSize="1rem" sx={{ mt: 2 }}>
              This action cannot be undone.
            </Typography>
          </>
        }
        actions={
          <div style={{ display: 'flex', gap: 8 }}>
            <ModalButton variant="outlined" onClick={handleCancelDelete} disabled={deletingRule}>
              Cancel
            </ModalButton>
            <ModalButton
              variant="contained"
              color="primary"
              onClick={handleDeleteRule}
              disabled={deletingRule}
            >
              {deletingRule ? 'Deleting...' : 'Delete Rule'}
            </ModalButton>
          </div>
        }
      />
    </Modal>
  );
};

export default DeleteRuleModal;
